import { render, staticRenderFns } from "./CommodityQDerivatives.vue?vue&type=template&id=33c81105&"
import script from "./CommodityQDerivatives.vue?vue&type=script&lang=js&"
export * from "./CommodityQDerivatives.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports